import MainLayout from "../layout/MainLayout";

const { Routes, Route } = require("react-router-dom");
const { default: Dashboard } = require("../pages/Dashboard");
const { default: ItemDetail } = require("../pages/ItemDetail");

const MainRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="/detail/:id" element={<ItemDetail />} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
